export const LG_NAMES = [
  "Agaie",
  "Agwara",
  "Bida",
  "Borgu",
  "Bosso",
  "Chanchaga",
  "Edati",
  "Gbako",
  "Gurara",
  "Katcha",
  "Kontagora",
  "Lapai",
  "Lavun",
  "Magama",
  "Mariga",
  "Mashegu",
  "Mokwa",
  "Munya",
  "Paikoro",
  "Rafi",
  "Rijau",
  "Shiroro",
  "Suleja",
  "Tafa",
  "Wushishi",
];
